import { useEffect, useState, useCallback, useRef } from 'react';
import { Image } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { SignIn } from "./Signin";
// import { Signout } from "./Signout";
import { useDispatch, useSelector } from 'react-redux'
import { authActions } from '_store'
import { resolveAvatarSrc } from 'utils/avatar';
import { useCompactPortrait, useNavigationAction } from 'components/navigation/NavigationContext';

function MenuSurface({ panelRef, onClose, children }) {
  return (
    <div className="custom-menu-overlay" onClick={onClose}>
      <nav ref={panelRef} className="custom-menu-panel" onClick={event => event.stopPropagation()}>
        {children}
      </nav>
    </div>
  );
}

const MENU_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'All Meetings', href: '/meetings' },
];

export default function Menu() {

  const url = process.env.REACT_APP_URL;
  const dispatch = useDispatch()
  const location = useLocation();
  const compact = useCompactPortrait();

  const [menuOpen, setMenuOpen] = useState(false);
  useNavigationAction('menu', {
    label: 'Menu',
    onClick: () => setMenuOpen(true),
    renderContent: ({ closeMore }) => (
      <nav aria-label="Main navigation" onClick={event => {
        if (event.target.closest('a')) closeMore();
      }}>
        {renderMenuContent()}
      </nav>
    ),
  });
  const [clubData, setClubData] = useState(null);
  // const [search, setSearch] = useState('');
  const [nextMeeting, setNextMeeting] = useState(null)


  const { user: authUser } = useSelector(x => x.auth)
  const authUserWrapper = authUser || null; // could be { user: { ... } } or user object directly
  const profile = authUserWrapper ? (authUserWrapper.user || authUserWrapper) : null;
  const profileLink = profile && profile._id ? `/profile/${profile._id}` : '/profile';
  const avatar = resolveAvatarSrc(profile?.avatarUrl || profile?.avatar || '');


  const [club, setClub] = useState([])

  // refs to detect outside clicks
  const toggleRef = useRef(null);
  const panelRef = useRef(null);

  const fetchData = useCallback(async (endpoint, setData) => {
    try {
      const response = await fetch(`${url}/${endpoint}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (response.ok) {
        const data = await response.json();
        setData(Array.isArray(data) ? data[0] : data);
      } else {
        console.error(`Error fetching ${endpoint}:`, response.statusText);
      }
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  }, [url]);

  const getClubData = useCallback(() => fetchData("club", setClubData), [fetchData]);

  const signout = (e) => {
    e.preventDefault()
    dispatch(authActions.logout())
  }

  useEffect(() => {
    if (clubData) {
      setClub(clubData)
    }
  }, [clubData])

  useEffect(() => {
    getClubData()
  }, [getClubData])

  // close when clicking outside the panel/toggle or press Escape
  useEffect(() => {
    if (!menuOpen) return;

    function onPointerDown(e) {
      const target = e.target;
      if (panelRef.current && panelRef.current.contains(target)) return;
      if (toggleRef.current && toggleRef.current.contains(target)) return;
      setMenuOpen(false);
    }
    function onKeyDown(e) {
      if (e.key === 'Escape') setMenuOpen(false);
    }

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  const filteredItems =

    // search
    //   ? (
    //     [
    //       ...MENU_ITEMS,
    //       ...(authUser ? [{ label: 'Users', href: '/users' }] : [])
    //     ].filter(item => item.label.toLowerCase().includes(search.toLowerCase()))
    //   )
    //   : 

    [
      ...MENU_ITEMS,
      ...(authUser ? [{ label: 'Users', href: '/users' }] : [])
    ];

  const getNextMeeting = useCallback(async () => {
    try {
      const response = await fetch(`${url}/meetings/comingup`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const data = await response.json()
      setNextMeeting(data)
    } catch (e) {
      console.log(`NavbarMenu - Next Meeting error: ${e}`)
    }
  }, [url])

  useEffect(() => {
    getNextMeeting()
  }, [getNextMeeting])

  const renderMenuContent = () => (
    <>
            {window.innerWidth < 769 ? (
              <div className="menu-header">
                <button className="close-menu" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button>
                <div className="menu-header-center text-center mx-auto">
                  <h4 className="club-name">{club.name}</h4>
                </div>
                {authUser &&
                  <Link to={profileLink} title="Profile">
                    <Image
                      src={avatar}
                      alt="Profile"
                      roundedCircle
                      style={{ width: 64, height: 64, objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)' }}
                    />
                  </Link>
                }
              </div>
            ) : (
              <div className="menu-header-desktop">
                {/* <button className="close-menu" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button> */}
                {authUser &&
                  <Link to={profileLink} title="Profile">
                    <Image
                      src={avatar}
                      alt="Profile"
                      roundedCircle
                      style={{ width: 64, height: 64, objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)' }}
                    />
                  </Link>
                }
              </div>
            )}
            <div className="menu-items">
              {filteredItems.length === 0 ? (
                <div className="menu-item disabled">No results</div>
              ) : (
                <>
                  {filteredItems.filter(item => item.label === 'Home').map(item => {
                    const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
                    return (
                      <Link
                        key={item.label}
                        to={item.href}
                        className={`menu-item${isActive ? ' active' : ''}`}
                        onClick={() => setMenuOpen(false)}

                      >
                        {item.label}
                      </Link>
                    );
                  })}
                  {nextMeeting && nextMeeting._id && (
                    (() => {
                      let label = 'Next Meeting';
                      if (nextMeeting.meetingDate) {
                        const today = new Date();
                        const [day, month, year] = nextMeeting.meetingDate.split('/').map(Number);
                        const meetingDate = new Date(year, month - 1, day);
                        if (
                          today.getFullYear() === meetingDate.getFullYear() &&
                          today.getMonth() === meetingDate.getMonth() &&
                          today.getDate() === meetingDate.getDate()
                        ) {
                          label = "Today's meeting";
                        }
                      }
                      return (
                        <Link
                          key="next-meeting"
                          to={`/meeting/${nextMeeting._id}`}
                          className={`menu-item${location.pathname === `/meeting/${nextMeeting._id}` ? ' active' : ''}`}
                          onClick={() => setMenuOpen(false)}
                        >
                          {label}
                        </Link>
                      );
                    })()
                  )}
                  {filteredItems.filter(item => item.label !== 'Home').map(item => {
                    const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
                    return (
                      <Link
                        key={item.label}
                        to={item.href}
                        className={`menu-item${isActive ? ' active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                </>
              )}
            </div>
            {/* <div className="menu-search">
              <input
                type="text"
                placeholder="Search or jump to..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div> */}
            {authUser ?
              <Link onClick={signout} className='menu-signout-btn'>Sign out</Link>
              :
              <SignIn />
            }
    </>
  );

  return (
    <>
      <div ref={toggleRef} className={`left-menu${menuOpen ? ' open' : ''}`}>
        <button
          className="left-menu-toggle"
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle main menu"
        >
          <span className="bi bi-list" />
        </button>
      </div>
      {!compact && menuOpen && (
        <MenuSurface panelRef={panelRef} onClose={() => setMenuOpen(false)}>
          {renderMenuContent()}
        </MenuSurface>
      )}
    </>
  );
}
